module.exports = __webpack_public_path__ + "img/title.9d2edbd.png";